import script from "./DuplicateAutomationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DuplicateAutomationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DuplicateAutomationDialog.vue?vue&type=style&index=0&id=4a7586e5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7586e5"]])